<template>
    <div>
        <div class="title">直播课程统计</div>
        <Select></Select>
        <TableOne v-if="first"></TableOne>
        <TableTwo v-else></TableTwo>
    </div>
</template>

<script>
import TableOne from "./TableOne.vue";
import TableTwo from "./TableTwo.vue";
import Select from "./select.vue";
export default {
    data() {
        return {
            isShow: false,
            first: true,
            // 机构
            organs: [
                {
                    value: "-不限机构-",
                },
            ],
            organ: "-不限机构-",
            // 时间
            teachers: [
                {
                    value: "-全部-",
                },
                {
                    value: "李老师",
                },
                {
                    value: "周老师",
                },
                {
                    value: "张老师",
                },
            ],
            teacher: "-全部-",
            className: "",
        };
    },
    components: {
        TableOne,
        TableTwo,
        Select,
    },
};
</script>


<style lang="scss" scoped>
.title {
    width: 100%;
    height: 58px;
    line-height: 58px;
    text-align: center;
    background-color: #409eff;
    font-size: 25px;
    font-weight: 700;
    color: #fff;
    margin-top: 3px;
}
</style>